// extracted by mini-css-extract-plugin
module.exports = {"edit":"InputBar_edit__ugogN"};